import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiGatewayHelperService } from 'modules/app/services/apigateway-helper.service';
import config from './config';


@Injectable()
export class TeacherHelperService {

    constructor(
        private http: HttpClient,
        private apiGatewayHelperService: ApiGatewayHelperService
    ) {
    }


    // Get User Spaces from local data (if available) or fetch from API
    public getSpacesAndClasses(dataNeeded, options: any = {}): Observable<any> {
        return this.http.post(config.app.api.baseUrl + this.apiGatewayHelperService.getApiGatewayPrefixUrl() + 'teacherSpacesAndBundles', { dataNeeded, options });
    }

}